import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Watchdogfield = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  const [idx, setIdx] = useState(0);
  const lastValueRef = useRef(value.value);
  const timeoutRef = useRef(null);

  // Effekt zur Überwachung von value.value
  useEffect(() => {
    // Wenn sich der Wert geändert hat
    if (value.value !== lastValueRef.current) {
      lastValueRef.current = value.value;
      setIdx(1);

      // Timer neu starten
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        setIdx(0);
      }, 2000); // 10 Sekunden
    }

    return () => {
      // Clean-up
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [value.value]);

  let states = ["", "", ""];
  let displayValue = ["", "", ""];

  if (props.props.states && props.props.states.length > 0) {
    states = props.props.states;
  }

  if (isFinite(idx)) {
    if (idx < props.element.states.length) {
      displayValue = states[idx];
    }
  }

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        visibility: props.props.visibility,
        cursor: "pointer",
      }}
      title={language.displayText(value.name)}
    >
      <output
        style={{
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          display: "flex",
          paddingLeft: "3%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          boxSizing: "border-box",
          maxWidth: `calc(${props.element.width} - 5%)`,
          justifyContent: props.element.textHorizontalAlignment,
          alignItems: props.element.textVerticalAlignment,
        }}
      >
        {language.displayText(displayValue)}
      </output>
    </div>
  );
});

export default Watchdogfield;
